// extracted by mini-css-extract-plugin
export default {"root":"K_wwW6","select":"uYaPzM","text":"WJw2u3"};